import * as React from "react";
const SvgTravel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#6C737F"
      d="m6.85 17.15-3.2-1.75 1.05-1.05 2.5.35 3.9-3.9-7.8-4.25 1.4-1.4 9.55 2.45 3.926-3.875a1.442 1.442 0 0 1 1.063-.425c.425 0 .78.141 1.062.425.283.283.425.637.425 1.063 0 .425-.142.78-.425 1.062l-3.9 3.9 2.45 9.55-1.4 1.4-4.25-7.8-3.9 3.9.35 2.5-1.05 1.05z"
    />
  </svg>
);
export default SvgTravel;